module.exports = __webpack_public_path__ + "static/media/07.7b396208.jpg";